import { cn } from "@newxsystems/shared";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightMedia } from "../../../../modules/content/components/DaylightMedia/DaylightMedia";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  direction,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaBlockProps) => {
  const videoDestination =
    video?.source === "direct"
      ? video.directVideo
      : video?.source === "youtube"
        ? video.youtubeVideo
        : video?.vimeoVideo;
  const copyFirst = direction !== "ltr";
  const hasCopy = Boolean(eyebrow || heading || description || buttons?.length);
  if (!image && !videoDestination) return null;

  const media = (
    <div className="flex min-w-0 flex-col gap-8">
      {image ? (
        <DaylightMedia
          aspectRatio={image.aspectRatio || "16:9"}
          media={image.image}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {video && videoDestination ? (
        <VideoPlayer
          banner={video.banner}
          directVideo={video.directVideo}
          source={video.source}
          vimeoVideo={video.vimeoVideo}
          youtubeVideo={video.youtubeVideo}
        />
      ) : null}
    </div>
  );

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      {hasCopy ? (
        <div className="grid grid-cols-1 border-t border-border md:grid-cols-2">
          <div
            className={cn(
              "flex min-w-0 items-center border-border p-8 md:p-12 lg:p-16",
              copyFirst ? "md:order-1 md:border-r" : "md:order-2 md:border-l",
            )}
          >
            <DaylightCommonContent
              alignment={alignment}
              buttons={buttons}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
            />
          </div>
          <div className={cn("min-w-0", copyFirst ? "md:order-2" : "md:order-1")}>{media}</div>
        </div>
      ) : (
        media
      )}
    </DaylightSection>
  );
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
